import { Component, OnInit, OnDestroy } from '@angular/core';

import { UserblockService } from './userblock.service';
import { SettingsService } from '../../../core/services/settings.service';
import { UserProfile } from '../../../core/api/resources/user-resources';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-userblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit, OnDestroy {

  public name: string = null;
  public role: string = null;
  public picture: string = null;


  constructor(private readonly userblockService: UserblockService, private readonly settings: SettingsService) {
  }

  public ngOnInit() {
    this.settings.userUpdated.subscribe((user) => {
      this.populate();
    });

    this.populate();

  }

  public ngOnDestroy(): void {
    //   this.mb.disconnect(this.conn);
  }

  public userBlockIsVisible() {
    return this.userblockService.getVisibility();
  }

  private populate() {
    const user = this.settings.getUserSetting();

    if(user.roles?.indexOf('admin') > -1) {
      this.role = 'Admin';
    }
    else if(user.roles?.indexOf('manager') > -1) {
      this.role = 'Manager';
    }
    else if(user.roles?.indexOf('user') > -1) {
      this.role = 'User';
    }
    else if(user.roles?.indexOf('client') > -1) {
      this.role = 'Client';
    }
    else{
      this.role =user.roles[0] ? user.roles[0] : 'Guest';
    }

    this.name = user.fullname ? user.fullname : 'John Doe';

    this.picture = user.picture ? user.picture : environment.ui.defaultProfile;
  }
}
